export default [
	{
		label: 'passengers.gender.male',
		value: 'passengers.gender.male'
	},
	{
		label: 'passengers.gender.female',
		value: 'passengers.gender.female'
	}
]
